import React, { ButtonHTMLAttributes } from 'react';
import { BiLoaderAlt } from 'react-icons/bi';

type ButtonProps = {
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    type?: 'submit' | 'button' | 'reset';
    size?: any;
    disabled?: boolean;
    text?:any;
    download?:any;
    className?: string;
    children?:any;
    id?:string;
    isLoaderShow?: boolean;
    title?: string;
    style?: React.CSSProperties;
}

const InputBtn = ({ onClick, className, type = 'button', id, children = 'Submit', isLoaderShow = false, title, ...rest }: ButtonProps) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`${className}`}
            id={id}
            title={title}
            {...rest}
        >
            {isLoaderShow ? <BiLoaderAlt className="animate-spin text-white-500" size={18} /> : children}
        </button>
    );
}

export default InputBtn;
